import React, { Component } from "react";
import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";
import LoadingIndicator from "../../components/LoadingIndicator";
import { fetchExpenses, addExpense, deleteExpense } from "../../store/expenses/operations";
import { getExpensesForProduct } from "../../store/expenses/selectors";
import { loggedInUserGuid } from "../../store/iam/selectors";
import UserDecorator from "../../containers/UserDecorator";
import ChatUser from "../../components/ExpenseChatUser";
import { getCircleWithId } from "../../store/my_circles/selectors";

import { Callout, Icon, Button } from "@blueprintjs/core";

import ExpenseForm from "../../components/ExpenseForm";
import validators from "./validators";
import UserTotalExpenses from "../../components/UserTotalExpenses";
import { Translate } from "react-redux-i18n";

class Expenses extends Component {
  state = {
    show_info: true,
    expense_loading: false
  };
  
  intervalId = undefined;
  
  componentDidMount(){
    this.refresh();
    if(!this.intervalId){
      this.intervalId = setInterval(this.refresh, 30000);
    }
  }

  componentWillUnmount(){
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
  }

  refresh=()=>{
    this.props.fetchExpenses(this.props.productId);
  }

  saveExpense = payload => {
    this.setState({ expense_loading: true });
    let expense = {
      spent_by: this.props.myGuid,
      sent_to: "",
      circle_guid: this.props.circleId,
      product_guid: this.props.productId,
      amount: String(payload.price),
      currency: "SEK",
      reason: payload.reason
    };
    this.props.addExpense(expense).then(() => {
      this.setState({ expense_loading: false });
    });
  };

  totalSpent = () => {
    let spent = 0;
    this.props.expenses.forEach(expense => {
      spent += parseFloat(expense.amount);
    });
    return `${spent} SEK`;
  };

  deleteExpense=(expense)=>{
    this.props.deleteExpense(expense).then(_=>{
      this.setState({expense_loading: false})
    }) 
  }

  render() {
    return (
      <>
        {this.state.show_info && (
          <Callout icon="info-sign" intent="primary" className="dismissable-note">
            {this.totalSpent()}
            <Translate value="expenses.total_spent" />

            {/* You owe{" "} <strong>383.33 SEK</strong> to <strong>Yolanda</strong>. */}
            <Button className="dismiss-note small" onClick={_ => this.setState({ show_info: false })}>
              <Icon icon="cross" iconSize="16" className="icon" />
            </Button>
          </Callout>
        )}
        <div className="chat-wrapper">
          <div className="chat-items">
            {this.props.expenses.map((expense, index) => (
              <UserDecorator userId={expense.spent_by} key={expense.guid} >
                <ChatUser myGuid={this.props.myGuid} expense={expense} locale={this.props.locale} deleteExpense={this.deleteExpense}/>
              </UserDecorator>
            ))}
          </div>

          <div className="sticky-bottom">
            <ExpenseForm validators={validators} onSave={this.saveExpense} loading={this.state.expense_loading} />
          </div>
        </div>
        <div className="table expenses">
          <div className="row header">
            <div className="column">
              <Translate value="expenses.user"/>  
            </div>
            <div className="column align-right">
              <Translate value="expenses.spent" /> (SEK)
            </div>             
          </div>
          {!this.props.circle && <LoadingIndicator />}
          {this.props.circle.members.map(memberId => (
            <UserDecorator userId={memberId} key={memberId}>
              <UserTotalExpenses expenses={this.props.expenses} />
            </UserDecorator>
          ))}           
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    locale: state.i18n.locale,
    myGuid: loggedInUserGuid(state),
    circle: getCircleWithId(state, props.circleId),
    expenses: getExpensesForProduct(state, props.productId)
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: to => dispatch(navigate(to)),
  fetchExpenses: productId => dispatch(fetchExpenses(productId)),
  addExpense: expense => {return dispatch(addExpense(expense));},
  deleteExpense: expense => {return dispatch(deleteExpense(expense));}
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Expenses);
